import useTranslation from '@/utils/hooks/translation/useTranslation';

import { classNames } from '@/utils';

import Dropdown from '@/components/base/Dropdown';
import Icon from '@/components/base/Icon';

type AIDropdownButtonProps = { isDisabled: boolean };

export function AIDropdownButton({ isDisabled }: AIDropdownButtonProps) {
    const { t } = useTranslation('caption');

    return (
        <Dropdown.Button
            data-testid="ai-dropdown-button"
            disabled={isDisabled}
            className={classNames(
                'inline-flex h-8 max-w-max items-center gap-2 rounded-full bg-icoBlue px-3 text-sm text-white focus:ring-0 focus:ring-offset-0 dark:bg-icoBlue/20 dark:text-icoBlue',
                'disabled:cursor-not-allowed disabled:bg-icoGray-300 disabled:text-icoGray-400 dark:disabled:bg-white/5 dark:disabled:text-icoDarkMode-wolf'
            )}
            name="dropdown-button">
            <Icon icon="edit-sparkle" />
            <span className="text-xs">{t('commons:ask_ai')}</span>
            <Icon icon="chevron-bottom" />
        </Dropdown.Button>
    );
}
